import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <img src="/Headerlogo.png" alt="ShopUSDT Logo" className="logo-img" />
          <span className="logo-text">ShopUSDT</span>
        </div>
        <nav className="nav">
          <a href="#home">HOME</a>
          <a href="#how-it-works">HOW IT WORKS</a>
          <a href="#roadmap">ROADMAP</a>
          <a href="#features">FEATURES</a>
          <a href="#contact">CONTACT US</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
